import { apiClient } from './client';
import type { AuthUser, LoginCredentials } from '@/shared/types';

export interface LoginResponse {
  token: string;
  user: AuthUser;
}

/** Forma cruda del usuario como la devuelve el portal (login y /user). */
interface ApiUsuario {
  id: number;
  nombre: string;
  email: string;
  cedula: string;
  roles: string[];
  permisos?: string[];
  permissions?: string[];
  companias: Array<{
    codigo: string;
    nombre: string;
    activa?: boolean;
  }>;
}

function mapUsuario(u: ApiUsuario): AuthUser {
  return {
    id: u.id,
    nombre: u.nombre,
    email: u.email,
    cedula: u.cedula,
    roles: u.roles ?? [],
    // El portal usa `permisos`; aceptamos también `permissions` por si
    // algún endpoint lo devuelve en inglés.
    permissions: u.permisos ?? u.permissions ?? [],
    companias: (u.companias ?? []).map(c => ({
      id: c.codigo,
      codigo: c.codigo,
      nombre: c.nombre,
    })),
  };
}

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  const { data } = await apiClient.post<{
    token: string;
    usuario: ApiUsuario;
  }>('/mobile/auth/login', { ...credentials, app: 'aurora-ef' });

  return {
    token: data.token,
    user: mapUsuario(data.usuario),
  };
}

export async function logout(): Promise<void> {
  await apiClient.post('/mobile/auth/logout');
}

export async function fetchCurrentUser(): Promise<AuthUser> {
  // Endpoint dedicado del portal con el mismo contrato del login
  // (el genérico /user devuelve el modelo Laravel crudo, sin permisos).
  const { data } = await apiClient.get<{ usuario: ApiUsuario }>(
    '/mobile/auth/me'
  );
  return mapUsuario(data.usuario);
}

export async function refreshToken(): Promise<{ token: string }> {
  const { data } = await apiClient.post<{ token: string }>('/mobile/auth/refresh');
  return data;
}
